import React from "react";
import { Link } from "react-router-dom";
import alertify from "alertifyjs";
import axios from "axios";
import UserActions from "../../Store/Actions/UserActions";
// import $ from 'jquery';
import ReactTooltip from "react-tooltip";
import APIModel from "../../Models/APIModel";
import * as moment from "moment";
import {
  displayAlertifyError,
  displayAlertifySuccess,
} from "../../util/functions";

class ForgotUsername extends React.Component {
  constructor() {
    super();
    this.state = {
      password: "",
      UserType: "",
      host: APIModel.HOST,
    };
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    alertify.set("notifier", "position", "top-right");
  }

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onFormSubmit = (e) => {
    e.preventDefault();
    let params = { social_security_number: this.state.password };

    if (this.state.password == "" || this.state.password === undefined) {
      displayAlertifyError({
        error: "Please enter your social security number",
      });
      return false;
    }

    return axios
      .post(this.state.host + "forgot/email", params, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
      .then((response) => {
        displayAlertifySuccess({ message: response.data.message });
      })
      .catch(this.globalErrorHandler)
      .finally();
  };

  globalErrorHandler = (error) => {
    const { response } = error;
    let message;
    if (response) {
      message = response.data.message;
    } else {
      message = error.toString();
    }
  };

  render() {
    return (
      <div class="container login-box d-flex justify-content-center align-items-center">
        <div class="container col-4">
          <div>
            <img
              src={process.env.PUBLIC_URL + "/logo512.png"}
              alt="Logo"
              className="logo"
            />
          </div>
          <h1 className="text-center title">BELLWOOD</h1>
          <h3 className="text-center sub-title">INVESTMENTS LLC</h3>
          <form onSubmit={this.onFormSubmit}>
            <label for="uname" className="input-lable">
              Forgot Username?
            </label>
            <br />
            <br />
            <div className="form-group">
              <input
                type="text"
                className="form-control input-box"
                onChange={this.onChange}
                id="password"
                value={this.state.password || ""}
                placeholder="Social security number"
                name="password"
              />
            </div>
            <button className="btn btn-primary float-right" type="submit">
              Send
            </button>
            <br />

            <div className="text-center">
              <Link to="/forgotPassword" className="link-colour forgot-link">
                Forgot password?
              </Link>
              <br />
              <Link to="/" className="link-colour back-login">
                Back to login
              </Link>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default ForgotUsername;
